<script>
    import Icon from 'views/components/icon/Icon.svelte'

    export let question
    export let link
    export let isInline = false
    export let hasNoMargin = false
</script>

<a
    class="faq"
    class:is-inline={isInline}
    class:has-no-margin={hasNoMargin}
    href={link}
    target="_blank"
    rel="noopener noreferrer">
    <Icon name="help-circle"></Icon>
    {question}
</a>

<style lang="scss">
    .faq {
        display: flex;
        align-items: center;
        background: $blue-10;
        color: $blue;
        border: 1px solid $blue-10;
        fill: currentColor;
        margin: 16px 0;
        padding: 10px 16px;
        font-size: 14px;
        border-radius: 12px;
        text-decoration: none;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }

        :global(svg) {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            flex-shrink: 0;
        }

        &.is-inline {
            margin: unset;
            padding: unset;
            border: unset;
            background: unset;
            display: inline-flex;
        }

        &.has-no-margin {
            margin: unset;
        }
    }
</style>
